"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareLicenseKey = SoftwareLicenseKey;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const SoftwareLicensesController_1 = require("./SoftwareLicensesController");
function SoftwareLicenseKey({ license }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [key, setKey] = (0, react_1.useState)(null);
    const [failed, setFailed] = (0, react_1.useState)(false);
    const request = (0, react_1.useRef)(null);
    const generation = (0, react_1.useRef)(0);
    const admin = MainSetupReact_1.default.currentUserOrNull?.systemRoleName === "ADMIN";
    function hide() {
        generation.current++;
        request.current?.abort();
        request.current = null;
        setKey(null);
        setOpen(false);
    }
    // A user event, not an effect: StrictMode must not duplicate an audited disclosure.
    async function reveal() {
        if (request.current || !admin)
            return;
        const controller = new AbortController();
        request.current = controller;
        const current = ++generation.current;
        setKey(null);
        setFailed(false);
        setOpen(true);
        try {
            const result = await (0, SoftwareLicensesController_1.licenseRequest)(`admin/softwareLicense/${license.id}/reveal-key`, "POST", undefined, controller.signal);
            if (generation.current !== current)
                return;
            if (MainSetupReact_1.default.currentUserOrNull?.systemRoleName === "ADMIN" && typeof result.licenseKey === "string")
                setKey(result.licenseKey);
            else
                setFailed(true);
        }
        catch {
            if (generation.current === current)
                setFailed(true);
        }
    }
    (0, react_1.useEffect)(() => () => { generation.current++; request.current?.abort(); }, []);
    (0, react_1.useEffect)(() => {
        if (!open)
            return;
        const visibility = () => { if (document.hidden)
            hide(); };
        const timer = window.setTimeout(hide, 30000);
        window.addEventListener("blur", hide);
        window.addEventListener("pagehide", hide);
        document.addEventListener("visibilitychange", visibility);
        return () => {
            window.clearTimeout(timer);
            window.removeEventListener("blur", hide);
            window.removeEventListener("pagehide", hide);
            document.removeEventListener("visibilitychange", visibility);
        };
    }, [open]);
    return react_1.default.createElement("div", { onClick: event => event.stopPropagation() },
        license.hasLicenseKey ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { "aria-label": "Klucz zas\u0142oni\u0119ty" }, "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"),
            admin && react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", className: "p-0 ms-2 text-secondary", "aria-label": "Poka\u017C klucz", title: "Poka\u017C klucz", onClick: reveal },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faEye, size: "lg" }))) : react_1.default.createElement("span", { className: "text-muted" }, "Brak klucza"),
        open && admin && react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: hide },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Klucz licencyjny")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                failed ? react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie mo\u017Cna ods\u0142oni\u0107 klucza. Sprawd\u017A po\u0142\u0105czenie i uprawnienia.")
                    : key === null ? react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", role: "status" },
                        react_1.default.createElement("span", { className: "visually-hidden" }, "\u0141adowanie klucza"))
                        : react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", readOnly: true, "aria-label": "Klucz licencyjny", value: key, rows: 4, autoComplete: "off", spellCheck: false }),
                react_1.default.createElement("p", { className: "text-muted mt-3 mb-0" }, "Klucz zostanie ukryty po 30 sekundach lub opuszczeniu okna. Ods\u0142oni\u0119cie jest rejestrowane.")),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { onClick: hide }, "Ukryj"))));
}
